import { TEndpoint } from 'contexts/app-context/types'
import { CLOUDFRONT_WEBVIEW_CONTENT_BASE_URL, IS_DEV_ENV } from 'common/constants'
import { AxiosRequestConfig } from 'axios'

import { TAppContext } from '../types'

const initialAppContext: TAppContext = {
  dispatch: () => {
    if (IS_DEV_ENV) {
      global.console.debug(
        'AppContext dispatch called before initialization. Make sure AppInitializer is properly set up.',
      )
    }
  },
  isAppActive: true,
  isAppLoading: true,
  isAppError: false,
  isQuickLoad: false,
  isUSBranch: false,
}

const getUserEntitiesEndpoint: TEndpoint = {
  id: 'getUserEntities',
  url: '/app-pf/central-privacidades/v1/userOrgsComTargetCluster',
  method: 'GET',
  isActive: true,
}

const getEntityMenuContentEndpoint: AxiosRequestConfig = {
  url: `${CLOUDFRONT_WEBVIEW_CONTENT_BASE_URL}/entity-menu/:language`,
  method: 'GET',
}

const getPrivacyCenterContentEndpoint: AxiosRequestConfig = {
  url: `${CLOUDFRONT_WEBVIEW_CONTENT_BASE_URL}/privacy-center/content/:country/:accountType/:entity/:language`,
  method: 'GET',
}

const getPrivacyCenterEndpointsEndpoint: AxiosRequestConfig = {
  url: `${CLOUDFRONT_WEBVIEW_CONTENT_BASE_URL}/privacy-center/endpoints/:country/:accountType/:entity`,
  method: 'GET',
}

export {
  initialAppContext,
  getUserEntitiesEndpoint,
  getEntityMenuContentEndpoint,
  getPrivacyCenterContentEndpoint,
  getPrivacyCenterEndpointsEndpoint,
}
